module.exports = __webpack_public_path__ + "img/route-highway.f6c83b3c.svg";